import { defineStore } from "pinia";
import { getApiAxios, postApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";

export const useLuckyWheelStore = defineStore("luckyWheel", {
  state: () => ({
    inforPopUpWinWheel: null,
    game_codes: null,
    dataImage: null,
    reward: null,
    userWinWheel: null,
    popUpWinWheel: null,
  }),

  getters: {
    getInforPopUpWinWheel(state) {
      return state.inforPopUpWinWheel;
    },
    getGameCodes(state) {
      return state.game_codes;
    },
    getDataImageWinWheel(state) {
      return state.dataImage;
    },
    getReward(state) {
      return state.reward;
    },
    getUserCheckWinWheel(state) {
      return state.userWinWheel;
    },
    getPopUpWinWheel(state) {
      return state.popUpWinWheel;
    },
  },
  actions: {
    async setInforWinWheel(params) {
      try {
        const response = await postApiAxios(api.luckyWheel.lucky_wheel_check, {
          phone: params.phone,
          game_codes: params.game_codes,
        });

        if (response.code === 200) {
          this.userWinWheel = true;
          return true;
        }

        if (response.code === 500) {
          this.userWinWheel = false;
          return false;
        }

        return false;
      } catch (error) {
        console.error("Error setting win wheel info:", error);
        this.userWinWheel = false;
        return false;
      }
    },
    setGameCode(data) {
      this.game_codes = data;
    },
  },
});
